module.exports = __webpack_public_path__ + "static/media/14UNEP22.2267d9f3.jpg";